import React, { useEffect, useRef, useState } from 'react'
import SlideUpWrapper from '../../components/Transitions/SlideUpWrapper'
import IssuerNavigator from '../../components/DashBoard/IssuerNavigator';
import style from "./CompanyProfile.module.css";
import templateStyles from "../DashBoard/Templates/Templates.module.css"
import API from "../../ApiConfig";
import { ATTRATION_INSIGHTS, BASE_URL, GET_ALL_COMPANIES, USER_TOKEN } from '../../Utils/constant';


import dropdownStyle from "../DashBoard/ExternalDash/Verifier/VerifyUsers.module.css";
import CompanyInsightCharts from './CompanyInsightCharts';
import ShimmerLoader from '../../components/ShimmerLoader';

import CustomDropDown from '../../components/CustomDropDown';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import SearchDropdown from './ExternalDash/Employment/searchDropdown';
import { AuthConsole } from '../../Utils/helper';
const CompanyInsight = () => {
    // useRefreshToken(BASE_URL + USER_TOKEN)
    const[loading , setLoading]=useState(false)
    const [GraphType, setGraphType]=useState("Pie Chart")
    const No_of_Days=[
      {
        no_of_days:"Last 1 Week",
        days:7
      },
      {
        no_of_days:"Last 1 Month",
        days:30
      },
      {
        no_of_days:"Last 1 Year",
        days:365
      }

  ]
    const insightTypes = ["company_insights", "location_insights", "designation_insights", "tenure_insights"]


    const[no_of_days, setNoofDays]=useState({no_of_days:"Last 1 Week", days:7})
    const[companiesList, setCompaniesList]=useState([])
    const[company, setCompany]=useState({id:1,name:"Authbridge"})


    const [chartData, setchartData]=useState({
        company_insights: {
          total_count: 10,
          grouped_data: {
            Google: 4,
            Amazon: 3,
            Microsoft: 2,
            Facebook: 1
          }
        },
        location_insights: {
          total_count: 6,
          grouped_data: {
            "Bangalore": 2,
            "Hyderabad": 1,
            "San Francisco": 1,
            "New York": 2
          }
        },
        designation_insights: {
          total_count: 5,
          grouped_data: {
            "Software Engineer": 2,
            "Product Manager": 1,
            "Data Analyst": 1,
            "QA Engineer": 1
          }
        },
        tenure_insights: {
          total_count: 4,
          grouped_data: {
            "0-1 year": 1,
            "1-3 years": 2,
            "3+ years": 1
          }
        }
      })
    useEffect(()=>{
        getAllCompanies_issuer()


    },[])
    const getAllCompanies_issuer=()=>{
        setLoading(true)
        API.get(GET_ALL_COMPANIES+`?company_type=Issuer`)
        .then(res=>{
          if(res.data.status==200){
            setLoading(false)
            setCompaniesList(res?.data?.data)

          }          
        })
        .catch(err=>{
            setLoading(false)
            AuthConsole(err);
          
        })
      }
      const companiesAttrationInsights=()=>{
        setLoading(true)
        let apiData={
          issuer_company_id:company.id,
          no_of_days:no_of_days.days
        }
        API.post(ATTRATION_INSIGHTS,apiData)
        .then(res=>{
          if(res.status==200){
            setLoading(false)
            setchartData(res.data.data)
          }
          
        })
        
        .catch(err=>{
          setLoading(false)
          AuthConsole(err);
          

          
        })
      }
      useEffect(()=>{
        companiesAttrationInsights()
      },[no_of_days, company])



      
      const transformData = (groupedData) => {
        return Object.entries(groupedData).map(([name, value]) => ({
          name,
          value,
        }));
      };

      // PDF Download function with charts
      const downloadPDF = async () => {
        try {
          const pdf = new jsPDF();
          let yPosition = 20;
          
          // FIRST PAGE - Company Information and Summary
          pdf.setFontSize(24);
          pdf.text('Attrition Insights Report', 20, yPosition);
          yPosition += 25;
          
          // Company details section
          pdf.setFontSize(16);
          pdf.text('Report Details', 20, yPosition);
          yPosition += 15;
          
          pdf.setFontSize(12);
          pdf.text(`Company: ${company.name}`, 30, yPosition);
          yPosition += 10;
          pdf.text(`Period: ${no_of_days.no_of_days}`, 30, yPosition);
          yPosition += 10;
          pdf.text(`Chart Type: ${GraphType}`, 30, yPosition);
          yPosition += 10;
          pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, 30, yPosition);
          yPosition += 25;
          
          // Summary section
          pdf.setFontSize(16);
          pdf.text('Summary Overview', 20, yPosition);
          yPosition += 15;
          
          pdf.setFontSize(12);
          insightTypes.forEach((type) => {
            const chartTypeData = chartData?.[type];
            if (chartTypeData?.grouped_data && chartTypeData?.unique_count > 0) {
              pdf.text(`${type.replace(/_/g, " ").toUpperCase()}: ${chartTypeData.total_count} total records`, 30, yPosition);
              yPosition += 8;
            }
          });
          
          yPosition += 20;
          pdf.setFontSize(10);
          pdf.text('Note: Detailed insights for each category are provided on the following pages.', 20, yPosition);
          
          // Get all chart sections
          const chartSections = document.querySelectorAll('.insight-chart-section');
          
          // Calculate total valid insights (with data > 0)
          const validInsights = insightTypes.filter(type => {
            const chartTypeData = chartData?.[type];
            return chartTypeData?.grouped_data && chartTypeData?.total_count > 0;
          });
          
          let currentPageNumber = 2; // Start from page 2 (after overview)
          
          // FROM SECOND PAGE ONWARDS - One insight per page
          for (let i = 0; i < insightTypes.length; i++) {
            const type = insightTypes[i];
            const chartTypeData = chartData?.[type];
            const rawData = chartTypeData?.grouped_data;
            
            if (rawData && chartTypeData?.unique_count > 0) {
              // Start new page for each insight
              pdf.addPage();
              yPosition = 20;
              
              // Page header
              pdf.setFontSize(18);
              pdf.text(type.replace(/_/g, " ").toUpperCase(), 20, yPosition);
              yPosition += 15;
              
              // Add total count
              pdf.setFontSize(12);
              pdf.text(`Total Count: ${chartTypeData.total_count}`, 20, yPosition);
              yPosition += 20;
              
              // Try to capture the specific chart section
              try {
                if (chartSections[i]) {
                  const chartContainer = chartSections[i].querySelector('.recharts-wrapper');
                  if (chartContainer) {
                    const canvas = await html2canvas(chartContainer, {
                      backgroundColor: '#ffffff',
                      scale: 2,
                      useCORS: true,
                      allowTaint: true,
                      height: chartContainer.scrollHeight,
                      width: chartContainer.scrollWidth
                    });
                    
                    const imgData = canvas.toDataURL('image/png');
                    const imgWidth = 290;  // Increased from 160
                    const imgHeight = (canvas.height * imgWidth) / canvas.width;
                    
                    // Center the image on the page
                    const xPosition = (210 - imgWidth) / 2;  // Center horizontally on A4 page
                    
                    pdf.addImage(imgData, 'PNG', xPosition, yPosition, imgWidth, imgHeight);
                    yPosition += imgHeight + 25;
                  }
                }
              } catch (chartError) {
                AuthConsole('Could not capture chart image:', chartError);
                yPosition += 30;
              }
              
              // Add data breakdown table
              pdf.setFontSize(14);
              pdf.text('Detailed Breakdown:', 20, yPosition);
              yPosition += 15;
              
              pdf.setFontSize(11);
              Object.entries(rawData).forEach(([key, value]) => {
                const percentage = ((value / chartTypeData.total_count) * 100).toFixed(1);
                pdf.text(`• ${key}: ${value} records (${percentage}%)`, 25, yPosition);
                yPosition += 8;
              });
              
              // Add page number
              pdf.setFontSize(8);
              pdf.text(`Page ${currentPageNumber} of ${validInsights.length + 1}`, 180, 285);
              
              currentPageNumber++; // Increment for next page
            }
          }
          
          // Add page number to first page
          pdf.setPage(1);
          pdf.setFontSize(8);
          pdf.text(`Page 1 of ${validInsights.length + 1}`, 180, 285);
          
          // Save the PDF
          const fileName = `Attrition_Insights_${company.name.replace(/[^a-zA-Z0-9]/g, '_')}_${no_of_days.no_of_days.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`;
          pdf.save(fileName);
          
        } catch (error) {
          console.error('Error generating PDF:', error);
          alert('Error generating PDF. Please try again.');
        }
      };
      
    const Dropdown = ({ listType, list, selectedOption, label, onSelect, type }) => {
                 const [isOpen, setIsOpen] = useState(false);
                 const dialogBox = useRef(null);
                 const handleToggle = () => {
                     setIsOpen(!isOpen);
                 };
         
                 useEffect(() => {
                     const handleClickOutside = (event) => {
                         if (dialogBox.current && !dialogBox.current.contains(event.target)) {
                             setIsOpen(false);
                         }
                     };
                     document.addEventListener('click', handleClickOutside);
                     return () => {
                         document.removeEventListener('click', handleClickOutside);
                     };
                 }, []);
                 const handleSelectItem=(item)=>{
                  onSelect(item, type)
                  setIsOpen(false)
                 }
                 if (listType == 0) {
                     return (
                         <div className={dropdownStyle.letter} ref={dialogBox} style={{ width: '15rem', padding:"0px 15px" }}>
                             <div className={dropdownStyle.lettertype} onClick={handleToggle} style={{ cursor: "pointer" }}>
                                 <div className={dropdownStyle.selectItem}>
         
                                     <p> {selectedOption?.name ? selectedOption.name : label}</p>
                                     {isOpen ? <img src='/chevrondown.svg' style={{ transform: "rotate(180deg)" }} /> : <img src='/chevrondown.svg' />}
                                 </div>
                             </div>
                             <div className={dropdownStyle.customDropdown} style={{ width: "inherit" }}>
                                 {isOpen && (
                                     <div className={dropdownStyle.dropdownOptions} style={{ maxHeight: '20rem', overflowY: 'scroll' }}>
                                         {list.map((i) => (
                                             <div key={i.id} className={dropdownStyle.dropdownList} onClick={() => handleSelectItem(i)}>
                                                 {i.name}
                                             </div>
                                         ))}
                                     </div>
                                 )}
                             </div>
                         </div>
                     );
                 } 
                }
    
    const handleSelect=(item)=>{
        setCompany(item)
    }
    const handleCharts=(e)=>{
        setGraphType(e)
    }
    const handleTime=(e)=>{
      

      setNoofDays(e)
    }
  return (
    
    <SlideUpWrapper direction='slide-left'>
         <div
        className={[style.companyProfile, templateStyles.templateHeader].join(
          " "
        )}
      >
        <IssuerNavigator
          title="Insights"
          actions={() => <></>}
          step={"/"}
        />
      </div>
      <div style={{ margin: "1rem", display:"flex", justifyContent:"space-between", alignItems:"center" }}>

        <div className={style.searchContainer}>
            <div style={{display:"flex", alignItems:"center"}}>
            {No_of_Days.map((item, index)=>(
                <div key={index} style={{marginTop:"10px"}}>
                    <div className={`${style.noOfDays} ${no_of_days.days==item.days? style.selected:null}`} onClick={()=>handleTime(item)}>{item.no_of_days}</div>
                </div>
            ))}
          <SearchDropdown apidata={companiesList} displayKey="name" placeholder='Select Issuer...' onSelect={(e)=>{setCompany(e)}} width='15rem' defaultValue={company}/>
          <div style={{ display: "flex", gap: "10px", alignItems: "center", marginLeft: "20px" }}>
            <CustomDropDown list={["Pie Chart", 'Bar Chart', 'Line Chart']} selectedOption={GraphType} onSelect={e => handleCharts(e)} />
          </div>
            </div>

        </div>
        
        <div>
          <button 
            onClick={downloadPDF}
            style={{
              padding: "8px 16px",
              backgroundColor: loading ? "#6c757d" : "#007bff",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: loading ? "not-allowed" : "pointer",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              transition: "background-color 0.2s",
              opacity: loading ? 0.6 : 1
            }}
            disabled={loading}
            onMouseOver={(e) => {
              if (!loading) e.target.style.backgroundColor = "#0056b3";
            }}
            onMouseOut={(e) => {
              if (!loading) e.target.style.backgroundColor = "#007bff";
            }}
          >
            <img src='/downloadoutline.svg' alt="download" width="16" height="16" />
            {loading ? 'Loading...' : 'Download PDF'}
          </button>
        </div>
        
        </div>



        <div style={{margin:"10px"}} id="insights-charts-container">
            {loading?<ShimmerLoader/>: 
            insightTypes.map((type) => {
              const chartTypeData = chartData?.[type];
              const rawData = chartTypeData?.grouped_data;
          
              if (!rawData) return null;
          
              const data = transformData(rawData ??{});
          
              return (
                  <div key={type} className="insight-chart-section">
                      <h3>{type.replace(/_/g, " ").toUpperCase()}</h3>
                      <CompanyInsightCharts data={data} Graph={GraphType} />
                  </div>
              )
    })
            }
            </div>
    </SlideUpWrapper>
  )
}

export default CompanyInsight